import ExportAPI from '@/apis/business/common/export-api.js'
import { HttpStatusCode } from '@/common/constant'
import CommonFn from '@/common/common-fn.ts'

export default {
  namespaced: true,

  actions: {
    /**
     * Xuất khẩu dữ liệu
     * @param {*} context
     * @param {*} param
     * @returns
     * @author BNDung
     */
    exportData (context, param) {
      return new Promise((resolve, reject) => {
        var data = JSON.stringify(param)
        ExportAPI.postAsync('param', data)
          .then((res) => {
            if (res.Data && res.Code === HttpStatusCode.OK) { CommonFn.downloadFileExcel(res.Data) } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
